import React, { useState } from "react";

import { useViewport } from "@/contexts/ViewportContext";
import { useAppNavigation } from "@/hooks/application/navigation";
import { useAddress, useDeleteAddress } from "@/hooks/domain/address";
import { Address } from "@/interfaces/domain/Address";
import { RootNavigation } from "@/navigation/Root";
import { AddressNavigation } from "@/navigation/stacks/AddressStack";

import AddressListMobile from "./AddressList.mobile";
import AddressListWeb from "./AddressList.web";
import AddressInfoModal from "./components/AddressInfoModal";

const AddressList = () => {
  const { isWebMode } = useViewport();

  const { goBack } = useAppNavigation<RootNavigation>();
  const { navigate } = useAppNavigation<AddressNavigation>();

  const { addressList, principalAddress, changePrincipalAddress } = useAddress();
  const { mutate, isLoading } = useDeleteAddress({
    onSuccess: () => {
      setModalVisible(false);
    },
  });

  const [modalVisible, setModalVisible] = useState(false);
  const [selectedAddress, setSelectedAddres] = useState<Address>(null);

  const onSelectAddress = (address: Address) => {
    changePrincipalAddress(address);
    goBack();
  };

  const onOpenAddressInfo = (address: Address) => {
    setModalVisible(true);
    setSelectedAddres(address);
  };

  const Screen = isWebMode ? AddressListWeb : AddressListMobile;

  return (
    <>
      <Screen
        addressList={addressList}
        principalAddressId={principalAddress?._id}
        onBack={goBack}
        onPressCreate={() => navigate("newAddress")}
        onSelectAddress={onSelectAddress}
        onOpenAddressInfo={onOpenAddressInfo}
      />
      <AddressInfoModal
        modalVisible={modalVisible}
        address={selectedAddress}
        isDeleting={isLoading}
        onClose={() => setModalVisible(false)}
        onPressDelete={() => mutate(selectedAddress?._id)}
      />
    </>
  );
};

export default AddressList;
